import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import RequestFlagIcon from "./FlagIcon";
import { tesaDarkGrey } from "../../styles/colors";
import StyledTooltip from "../Wrapper/StyledTooltip";
import Flag, { FLAGS_ORDERED, FLAG_TOOLTIPS_MAPPING } from "./Flag";

export const GUTTER_SPACING_DEFAULT = 2;

const useStyles = makeStyles((theme) => ({
  colorDark: {
    color: tesaDarkGrey,
  },
  noMinWidth: {
    minWidth: 0,
  },
  listHorizontal: (props: RequestFlagIconListProps) => ({
    display: "inline-flex",

    "& > * + *": {
      marginLeft: theme.spacing(props.gutterSpacing ?? GUTTER_SPACING_DEFAULT),
    },
  }),
  noPadding: {
    padding: 0,
  },
}));

export interface RequestFlagIconListProps {
  flags: Flag[] | undefined;
  gutterSpacing?: number;
}

function FlagIconList(props: RequestFlagIconListProps) {
  const { flags } = props;
  const classes = useStyles(props);
  const flagsOrdered = flags?.length ? FLAGS_ORDERED.filter((flag) => flags.includes(flag)) : null;

  if (!flagsOrdered) {
    return null;
  }

  return (
    <List className={classes.listHorizontal} disablePadding>
      {flagsOrdered.map((flag) => (
        <StyledTooltip title={FLAG_TOOLTIPS_MAPPING[flag]} key={flag}>
          <ListItem classes={{ root: classes.noPadding }} disableGutters key={flag}>
            <ListItemIcon classes={{ root: clsx(classes.colorDark, classes.noMinWidth) }}>
              <RequestFlagIcon flag={flag} />
            </ListItemIcon>
          </ListItem>
        </StyledTooltip>
      ))}
    </List>
  );
}

export default FlagIconList;
